const LETTER_REGEX = /[^a-zA-Z]/g;

class LettersOnlyFormatter {
  constructor() {
    this.preFormat = true;
  }

  static tryParse(format) {
    return format === 'letters-only' ? new LettersOnlyFormatter() : null;
  }

  apply(value) {
    if (!value) return '';

    return value.toString().replace(LETTER_REGEX, '');
  }

  parse(value) {
    return value;
  }
}

export default LettersOnlyFormatter;
